module.exports = __webpack_public_path__ + "static/02-a8e83239bca958544a47348a35e86735.jpg";